import { NavLink } from 'react-router-dom';
import { Camera, Heart, House, Refrigerator, UserRound } from 'lucide-react';

const TABS = [
  { to: '/today', label: 'Home', Icon: House },
  { to: '/kitchen', label: 'Pantry', Icon: Refrigerator },
  null, // the Scan button sits in the middle
  { to: '/favorites', label: 'Favorites', Icon: Heart },
  { to: '/you', label: 'Profile', Icon: UserRound },
] as const;

/**
 * Four destinations and one action. Scanning is the app's core action, so it sits in the middle as
 * the one filled button; everything else is a place. A plain bar fixed to the bottom edge (not
 * floating), so nothing on the screen hides behind it.
 */
export function TabBar() {
  return (
    <nav aria-label="Main" className="fixed inset-x-0 bottom-0 z-40 bg-surface border-t border-line" style={{ paddingBottom: 'var(--safe-bottom)' }}>
      <ul className="grid grid-cols-5 items-center h-[58px] max-w-[560px] mx-auto">
        {TABS.map((t, i) => t === null ? (
          <li key="scan" className="flex justify-center">
            <NavLink to="/scan" aria-label="Scan your food"
              className="w-[50px] h-[42px] rounded-[14px] bg-primary text-primary-on flex items-center justify-center transition-transform active:scale-95">
              <Camera size={23} strokeWidth={2.2} aria-hidden />
            </NavLink>
          </li>
        ) : (
          <li key={t.to + i}>
            <NavLink to={t.to}
              className={({ isActive }) => `flex flex-col items-center justify-center gap-[3px] h-[58px] text-[11px] leading-[13px] font-semibold ${isActive ? 'text-primary' : 'text-fg-muted'}`}>
              {({ isActive }) => (
                <>
                  <t.Icon size={24} strokeWidth={isActive ? 2.3 : 1.8} fill={isActive && t.to === '/favorites' ? 'currentColor' : 'none'} aria-hidden />
                  {t.label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
